// Mock data for Tech Masters Solutions

export const contactInfo = {
  phone: '2033170884',
  phoneFormatted: '203-317-0884',
  phoneLink: '+12033170884',
  email: 'stechmasters@gmail.com',
  location: 'Connecticut',
  whatsappMessage: 'Hola, necesito servicio de Tech Masters Solutions'
};

export const services = [
  {
    id: 1,
    icon: '⚡',
    title: 'Reparaciones Eléctricas',
    description: 'Diagnóstico, reparación y soluciones eléctricas rápidas y seguras para hogar y negocio.'
  },
  {
    id: 2,
    icon: '💻',
    title: 'Diseño Web',
    description: 'Páginas modernas para negocios que buscan verse profesionales y conseguir más clientes.'
  },
  {
    id: 3,
    icon: '🛠',
    title: 'Soporte Técnico',
    description: 'Ayuda con computadoras, configuración, optimización, reparación y soporte digital.'
  }
];

export const benefits = [
  {
    id: 1,
    icon: '⚡',
    title: 'Servicio de Emergencia 24/7',
    description: 'Atendemos emergencias eléctricas a cualquier hora. Llámanos y estaremos en tu hogar o negocio el mismo día.'
  },
  {
    id: 2,
    icon: '🏠',
    title: 'Residencial y Comercial',
    description: 'Servimos tanto a propiedades residenciales como comerciales en todo Connecticut con la misma calidad profesional.'
  },
  {
    id: 3,
    icon: '🔧',
    title: 'Técnicos Certificados',
    description: 'Nuestros electricistas están completamente licenciados, asegurados y capacitados en las últimas tecnologías.'
  },
  {
    id: 4,
    icon: '💯',
    title: 'Satisfacción Garantizada',
    description: 'Trabajo de calidad respaldado por garantía. Tu satisfacción es nuestra prioridad número uno.'
  }
];

export const reviews = [
  {
    id: 1,
    rating: 5,
    text: 'Muy profesional y rápido. Excelente servicio y buena comunicación.',
    author: 'Cliente Local'
  },
  {
    id: 2,
    rating: 5,
    text: 'Me resolvió el problema eléctrico el mismo día. Lo recomiendo.',
    author: 'Cliente en Connecticut'
  },
  {
    id: 3,
    rating: 5,
    text: 'Buena atención, imagen profesional y servicio confiable de principio a fin.',
    author: 'Cliente Comercial'
  }
];

export const paymentMethods = [
  { id: 1, name: 'Zelle', link: '#', pending: true },
  { id: 2, name: 'Cash App', link: '#', pending: true },
  { id: 3, name: 'Venmo', link: '#', pending: true }
];

export const images = {
  logo: 'https://customer-assets.emergentagent.com/job_tech-ct/artifacts/917ybyua_6B480388-2114-489F-BA49-0495B1020E34.jpeg',
  hero: 'https://customer-assets.emergentagent.com/job_tech-ct/artifacts/917ybyua_6B480388-2114-489F-BA49-0495B1020E34.jpeg',
  banner: 'https://customer-assets.emergentagent.com/job_tech-ct/artifacts/kb39h20u_CBF7BE98-F684-4CEA-A7F1-FC756A304A54.png',
  robot: 'https://customer-assets.emergentagent.com/job_tech-ct/artifacts/kb39h20u_CBF7BE98-F684-4CEA-A7F1-FC756A304A54.png'
};
